<app-chat-wrapper *ngIf="!loadingChat; else loading" [contentPosition]="'bottom'"
  [isStreamingResponse]="isStreamingResponse" (promptSubmit)="onPromptSubmit($event)"
  (stopStreaming)="stopStreaming()" [showImageManager] = "hasCompletedResponse">
  <div id="chat-container" #chatContainer (scroll)="onScroll($event)">
    <div class="messages-wrapper">
      <div class="message-bubble" *ngFor="let msg of messages">
        <ng-container *ngIf="msg.user">
          <app-user-message [chatMessage]="msg.user.content" (openSavePromptModal)="openSaveModal($event)" (thumbnailReferencesExpanded)="skipAutoScroll()"/>
        </ng-container>
        <ng-container *ngIf="msg.assistant">
          <ng-container *ngIf="!msg.isGenerating; else generatingResponse">
            <ng-container *ngIf="msg.assistant | async as assistantMsg">
              <app-assistant-message #assistantMessage [messageNode]="assistantMsg" [isGeneratingResponse]="false" [isMessageCompleted]="isMessageCompleted"
              [imageCache]="imageCache"
                (regenerateResponse)="regenerateResponse($event)"
                (activeMessageChange)="onActiveAssistantMessageChange($event)" />
            </ng-container>
          </ng-container>
          <ng-template #generatingResponse>
            <app-assistant-message #assistantMessage [isGeneratingResponse]="true" [imageCache]="imageCache" />
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="missing-files-notification" *ngIf="(showMissingFilesNotification || (isChatDisabled && featureFlags.retentionPolicyChip))">
    <core-notification
      label='{{labelText}}'
      message='{{messageText}}'
      variant='inline'
      state='error'
      timer='0'
      nocloseicon = {{isChatDisabled}}
    ></core-notification>
  </div>

</app-chat-wrapper>
<ng-template #loading>
  <div class="loading-wheel-wrapper">
    <kmd-loading-wheel *ngIf="loadingChat"></kmd-loading-wheel>
  </div>
</ng-template>
<app-modal-save-prompt id="savePromptId" #savePromptComponent [prompt]="selectedPrompt!"
  (promptSaveEvent)="savePrompt()" />
